import { render, staticRenderFns } from "./FixedCoverageType.vue?vue&type=template&id=c482a62e&scoped=true"
import script from "./FixedCoverageType.vue?vue&type=script&lang=js"
export * from "./FixedCoverageType.vue?vue&type=script&lang=js"
import style0 from "./FixedCoverageType.vue?vue&type=style&index=0&id=c482a62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c482a62e",
  null
  
)

export default component.exports